import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from 'axios';
import Paginator from "../../components/Paginator";
import InnerNav from "../../components/InnerNav";
import Wrapper from "../../components/Wrapper";
import { AiFillEdit, AiFillDelete } from "react-icons/ai";
const ReceiveBulkStakes = ()=>{
    const [receiveBulkStake, setReceiveBulkStake] = useState([]);
    const [page, setPage] = useState(1);
    const [lastPage, setLastPage] = useState(1);
    useEffect(() => {
        (
        async () => {

            const {data} = await axios.get(`receiveBulkStake?page=${page}`);
            setReceiveBulkStake(data.data);
            setLastPage(data.meta.last_page)

        }
        )();
    },[page]);
    const del = async (id) =>{
        if(window.confirm("Are you sure you want to delete this record?")){
            await axios.delete(`receiveBulkStake/${id}`);
            setReceiveBulkStake(receiveBulkStake.filter((receiveBulkStake) => receiveBulkStake.id !== id));
        }
    }
    return (
        <Wrapper pageTitle={'Stake Data'}>
            <InnerNav createLink={'/receiveBulkStakeCreate'} listLink={'/receiveBulkStakes'} />
                <div className="w-full overflow-hidden rounded-lg shadow-xs">
                    <div className="w-full overflow-x-auto">
                        <table className="w-full whitespace-no-wrap">
                            <thead>
                                <tr className="text-xs font-semibold tracking-wide text-left text-gray-500 uppercase border-b dark:border-gray-700 bg-gray-50 dark:text-gray-400 dark:bg-gray-800" >
                                    <th className="px-4 py-3">#Ref </th>
                                    <th className="px-4 py-3">Betid </th>
                                    <th className="px-4 py-3">Customer Id </th>
                                    <th className="px-4 py-3">Mobile No </th>
                                    <th className="px-4 py-3">Punter Amt </th>
                                    <th className="px-4 py-3">Desc </th>
                                    <th className="px-4 py-3">Stake Amt </th>
                                    <th className="px-4 py-3">Stake Type </th>
                                    <th className="px-4 py-3">Odds </th>
                                    <th className="px-4 py-3">Date Of Stake </th>
                                    <th className="px-4 py-3">Excise Amt </th>
                                    <th className="px-4 py-3">Wallet Balance Stake </th>
                                     <th className="px-4 py-3">Action</th>
                                </tr>
                                </thead>
                                <tbody className="bg-white divide-y dark:divide-gray-700 dark:bg-gray-800" >
                                    {receiveBulkStake && receiveBulkStake.length > 0 ? (
                                         receiveBulkStake.map((receiveBulkStake)=>(
                                             <tr key={receiveBulkStake.id} className="text-gray-700 dark:text-gray-400">
                                                 <td className="px-4 py-5">{receiveBulkStake.id}</td>
                                                 <td className="px-4 py-3 text-sm">{receiveBulkStake.betId}</td>
                                                 <td className="px-4 py-3 text-sm">{receiveBulkStake.customerId}</td>
                                                 <td className="px-4 py-3 text-sm">{receiveBulkStake.mobileNo}</td>
                                                 <td className="px-4 py-3 text-sm">{receiveBulkStake.punterAmt}</td>
                                                 <td className="px-4 py-3 text-sm">{receiveBulkStake.desc}</td>
                                                 <td className="px-4 py-3 text-sm">{receiveBulkStake.stakeAmt}</td>
                                                 <td className="px-4 py-3 text-sm">{receiveBulkStake.stakeType}</td>
                                                 <td className="px-4 py-3 text-sm">{receiveBulkStake.odds}</td>
                                                 <td className="px-4 py-3 text-sm">{receiveBulkStake.dateOfStake}</td>
                                                 <td className="px-4 py-3 text-sm">{receiveBulkStake.exciseAmt}</td>
                                                 <td className="px-4 py-3 text-sm">{receiveBulkStake.walletBalanceStake}</td>
                                                 <td className="flex px-4 py-3 text-sm"><Link className="btn btn-sm btn-outline-secondary px-5" to={`/receiveBulkStake/${receiveBulkStake.id}/edit`}><AiFillEdit/> </Link><span className="btn btn-sm btn-outline-secondary" onClick={()=>del(receiveBulkStake.id)}> <AiFillDelete className="text-rose-500 text-lg"/></span></td>
                                             </tr>
                                         ))
                                ) : (
                                            <tr>
                                                <td colSpan="13" className="text-center py-5 text-gray-500">No data to display </td>
                                            </tr>
                                         )}
                            </tbody>
                        </table>
                    </div>
                    <Paginator lastPage={lastPage} pageChanged={setPage} />
                </div>
             </Wrapper>
         );
};
export default ReceiveBulkStakes;